import React from 'react';
import { Placeholder, Table } from 'react-bootstrap';

export function CalendarListRowsSkeleton({ rows = 6 }: { rows?: number }) {
    return (
        <Placeholder as="tbody" animation="glow" aria-hidden="true">
            {Array.from({ length: rows }).map((_, i) => (
                <tr key={i}>
                    <td className="text-nowrap">
                        <div className="d-flex align-items-center">
                            <Placeholder className="skeleton skeleton-company-logo mr-2" />
                            <Placeholder className="skeleton skeleton-table-name" />
                        </div>
                    </td>
                    <td className="text-center">
                        <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide" />
                    </td>
                    <td className="text-center">
                        <div className="d-flex flex-column align-items-center">
                            <Placeholder className="skeleton skeleton-platform-icon" />
                            <Placeholder className="skeleton skeleton-table-cell mt-1" />
                        </div>
                    </td>
                    <td>
                        <div className="d-flex align-items-center justify-content-center">
                            <Placeholder className="skeleton skeleton-company-logo mr-2" />
                            <Placeholder className="skeleton skeleton-table-cell" />
                        </div>
                    </td>
                    <td className="text-center">
                        <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide" />
                    </td>
                    <td className="text-center">
                        <Placeholder className="skeleton skeleton-badge" />
                    </td>
                </tr>
            ))}
        </Placeholder>
    );
}

export function CalendarListLoaderSkeleton() {
    return (
        <Table className="table-vertical-center mb-0">
            <CalendarListRowsSkeleton rows={2} />
        </Table>
    );
}
